<template>
    <b-container>
        <vue-good-table
                v-if="true"
                :columns="columns"
                :rows="rows"
                styleClass="vgt-table condensed table-bordered table-striped"
                @on-row-click="onRowClick"
                :sort-options="{
                    enabled: true,
                    initialSortBy: {
                        field: 'loginDate',
                        type: 'desc'
                    }
                }"
                :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 50,
                    position: 'top',
                    perPageDropdown: [50, 100, 200],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                }">
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.label === 'Account Info'">
                    <b-button size="sm"
                              @click="goToAccountInfo(props.column.field,props.formattedRow[props.column.field])">
                            Account Info
                    </b-button>
                </span>
                <span v-else-if="props.column.label === 'Calculator'">
                    <b-button size="sm"
                              @click="goToCalculator(props.formattedRow[props.column.field])">Metrics Summary</b-button>
                </span>
                <span v-else-if="props.column.label === 'Certify'">
                    <b-button size="sm"
                              @click="certify(props.formattedRow['surveyId'], data.item.winery, props.formattedRow['groupId'])">
                    Certify
                    </b-button>
                </span>
                <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                </span>
            </template>
        </vue-good-table>
    </b-container>
</template>

<script>
// import the styles
import 'vue-good-table/dist/vue-good-table.css'
import {VueGoodTable} from 'vue-good-table';

export default {
    name: "MigrationController",
    components: {
        VueGoodTable
    },
    data() {
        return {
            columns: [
                {
                    label: "Migration Id",
                    field: "id"
                },
                {
                    label: "Migration Name",
                    field: "name"
                },
                {
                    label: "Executed",
                    field: "executed"
                },
                {
                    label: "Execution Date",
                    field: "executionDate",
                    type: 'date',

                    formatFn: value => {
                        if (value === "" || value === null) {
                            return "Unknown";
                        }

                        let date = new Date(0);

                        date.setUTCMilliseconds(value);

                        let options = {
                            weekday: 'long',
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                            hour: 'numeric',
                            minute: 'numeric'
                        };
                        return date.toLocaleDateString("en-US", options)
                    }
                },
                {
                    label: "Executor Id",
                    field: "executorId"
                }],
            items: [],
            rows: []
        }
    },
}
</script>

<style scoped>

</style>
